export interface TaskSettings {
  checklistRequired: boolean;
  checklistFieldsRequired: boolean;
  attachmentRequired: boolean;
  commentRequired: boolean;
}

export const DefaultTaskSettings: TaskSettings = {
  checklistRequired: false,
  checklistFieldsRequired: false,
  attachmentRequired: false,
  commentRequired: false,
};

